import React, { useContext, useEffect, useState } from "react";
import InputMask from "react-input-mask";

import { Back, Hero, LinearGradient, Next } from "../../../../components";

import { Container, Section, NavigateButtons } from "./styles";
import { DataUserContext, NavigateButtonsContext } from "../..";

import emailValidator from "../../../../utils/email-validation";
import phoneValidator from "../../../../utils/phone-validation";
import nameValidator from "../../../../utils/name-validation";
import { ThemeContext, DefaultTheme } from "styled-components";
import { sendArchitectData } from "../../../../services/data-service/api";
import eventTypes from "../../../../events/event-types.const";
import HistoryPages from "../../../../events";
import can from "../../../../utils/can";

const Question07: React.FC = () => {
  const { next } = useContext(NavigateButtonsContext);
  const { token } = useContext(DataUserContext);

  const [name, setName] = useState<string>("");
  const [email, setEmail] = useState<string>("");
  const [phone, setPhone] = useState<string>("");

  const [error, setError] = useState<number>(0);

  const [requirementsFulfilled, setRequirementsFulfilled] =
    useState<boolean>(false);

  useEffect(() => {
    HistoryPages.emit(eventTypes.SAVE, 8);
  }, []);

  useEffect(() => {

    var emailVal = emailValidator(email),
        phoneVal = phoneValidator(phone);
        
    setRequirementsFulfilled(true);
    
    if ( !nameValidator(name) )
      setRequirementsFulfilled(false);
    
    if( !email && !phone )
      setRequirementsFulfilled(false);
      
    if( email && !emailVal )
        setRequirementsFulfilled(false);
      
    if( phone && !phoneVal )
      setRequirementsFulfilled(false);
    
  }, [name, email, phone]);

  function submit() {
    if (requirementsFulfilled) {
      sendArchitectData(
        {
          nome_arquiteto: name,
          telefone_arquiteto: phone,
          email_arquiteto: email,
        },
        token
      );

      next(11);
    } else setError((prevState) => prevState + 1);
  }

  const _theme = useContext(ThemeContext);
  const [theme, setTheme] = useState({} as DefaultTheme);

  useEffect(() => {
    if (_theme.steps) setTheme(_theme);
  }, [_theme]);

  return (
    <>
      {theme.status === "success" && (
        <Container>
          <Hero
            criare
            image={can(
              theme,
              "theme.steps.etapa_dados_arquiteto.propriedades.imagens.etapa_dados_arquiteto_imagemBanner.url"
            )}
            title={can(
              theme,
              "theme.steps.etapa_dados_arquiteto.propriedades.banner.subtituloBanner"
            )}
          />

          <Section>
            <p>
              {can(
                theme,
                "theme.steps.etapa_dados_arquiteto.propriedades.conteudo.titulo"
              )}
            </p>

            <form>
              <input
                type="text"
                value={name}
                onChange={(e) => setName(e.target.value)}
                placeholder="Nome do profissional"
              />
              <InputMask
                mask="99 9 9999.9999"
                value={phone}
                onChange={(e) => setPhone(e.target.value)}
                placeholder="Telefone do profissional"
              />
              <input
                type="text"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="E-mail do profissional"
              />
            </form>
          </Section>

          <NavigateButtons>
            <Back criare onClick={() => next(HistoryPages.getLastPage())} />
            <Next criare onClick={submit} animationTrigger={error} />
          </NavigateButtons>

          <LinearGradient />
        </Container>
      )}
    </>
  );
};

export default Question07;
